<template>
    <b-tab :title="$store.state.localization.data.mainPage.clients.tabs.companies"
            >
              <div
                class="row no-gutters"
                style="margin-left: 5px; margin-bottom: 5px"
              >
                <div class="col-5">
                  <b-form-select
                    v-model="companies.left.data"
                    :options="companies.left.values"
                    multiple
                    :select-size="12"
                    style="font-size: 12px"
                    ref="companiesLeftRef"
                  ></b-form-select>
                </div>
                <div class="col-1 align-self-center" style="text-align: center">
                  <b-button-group vertical>
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="selectCompanies"
                      >&#62;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="selectAllCompanies"
                      >&#62;&#62;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="deselectAllCompanies"
                      >&#60;&#60;</b-button
                    >
                    <b-button
                      size="sm"
                      style="font-size: 12px"
                      variant="success"
                      @click="deselectCompanies"
                      >&#60;</b-button
                    >
                  </b-button-group>
                </div>
                <div class="col-5">
                  <b-form-select
                    v-model="companies.right.data"
                    :options="companies.right.values"
                    multiple
                    :select-size="12"
                    style="font-size: 12px"
                    ref="companiesRightRef"
                  ></b-form-select>
                </div>
              </div>
      </b-tab>
  </template>
  
  <script>
  
  export default {
    name: "CompaniesTab",
    props: {
      user: Object,
      allCompanies: [],
    },
    data() {
      return {
        companies: {
          left: {
            data: [],
            values: [],
          },
          right: {
            data: [],
            values: [],
          },
        },
      };
    },
    created() {
      this.companies.left.data = [];
      this.companies.left.values = [];
      this.companies.right.data = [];
      this.companies.right.values = [];

      for (let i = 0; i < this.allCompanies.length; i++) {
          const role = this.user.companies.find(
            (x) => x == this.allCompanies[i].id
          );
          if (role) {
            this.companies.right.values.push({
              value: this.allCompanies[i].id,
              text: this.allCompanies[i].name,
            });
          } else {
            this.companies.left.values.push({
              value: this.allCompanies[i].id,
              text: this.allCompanies[i].name,
            });
          }
        }
    },
    methods: {
      getCompanies() {
        const companies = [];

        for (let i = 0; i < this.companies.right.values.length; i++) {
          companies.push(this.companies.right.values[i].value);
        }

        return companies;
      },
      selectCompanies() {
        for (let i = 0; i < this.companies.left.data.length; i++) {
          const columnIndex = this.companies.left.values.findIndex(
            (x) => x.value == this.companies.left.data[i]
          );

          this.companies.right.values.push(
            this.companies.left.values[columnIndex]
          );
          this.companies.left.values.splice(columnIndex, 1);
        }
      },
      selectAllCompanies() {
        for (let i = 0; i < this.companies.left.values.length; i++) {
          this.companies.right.values.push(
            this.companies.left.values[i]
          );
        }

        this.companies.left.data = [];
        this.companies.left.values = [];
      },
      deselectCompanies() {
        for (let i = 0; i < this.companies.right.data.length; i++) {
          const columnIndex = this.companies.right.values.findIndex(
            (x) => x.value == this.companies.right.data[i]
          );

          this.companies.left.values.push(
            this.companies.right.values[columnIndex]
          );
          this.companies.right.values.splice(columnIndex, 1);
        }
      },
      deselectAllCompanies() {
        for (let i = 0; i < this.companies.right.values.length; i++) {
          this.companies.left.values.push(
            this.companies.right.values[i]
          );
        }

        this.companies.right.data = [];
        this.companies.right.values = [];
      },
    },
  };
  </script>
  